import KSwitch from './k-switch.vue';
export default KSwitch;



// WEBPACK FOOTER //
// ./src/components/k-switch/index.js